import { z } from "zod";
import { makeRoute } from "@/lib/router/utils";

export const Routes = {
	// App: makeRoute("/app"),
	Dashboard: makeRoute("/dashboard"),

	// === Core Values ===
	CoreValuesSort: makeRoute("/core-values/sort"),
	CoreValuesDashboard: makeRoute("/core-values"),
	CoreValuesExplainer: makeRoute("/core-values/explainer"),
	CoreValuesChat: makeRoute("/core-values/chat", z.object({ id: z.string().optional() })),
	CoreValuesDetails: makeRoute("/core-values/details", z.object({ id: z.string().optional() })),
	CoreValuesOverview: makeRoute("/core-values/overview"),
	// === Friendcheck ===
	FriendCheckDashboard: makeRoute("/friend-check"),
	FriendCheckExplainer: makeRoute("/friend-check/explainer"),
	FriendCheckSubmission: makeRoute(
		"/friend-check/submission",
		z.object({ id: z.string().optional() }),
	),
	FriendCheckGenerate: makeRoute("/friend-check/generate"),

	// === Reflection ===
	ReflectionExplainer: makeRoute("/reflection/explainer"),
	ReflectionQuestion: makeRoute("/reflection/question", z.object({ id: z.string().optional() })),
	ReflectionGenerate: makeRoute("/reflection/generate"),
	ReflectionDetails: makeRoute("/reflection/details"),

	// === Perfect Day ===
	PerfectDayDashboard: makeRoute("/perfect-day"),
	PerfectDayExplainer: makeRoute("/perfect-day/explainer"),
	PerfectDayDetails: makeRoute("/perfect-day/details", z.object({ id: z.string().optional() })),
	PerfectDayChat: makeRoute("/perfect-day/chat", z.object({ id: z.string().optional() })),

	// === Your Mission ===
	YourMission: makeRoute("/your-mission"),
	YourMissionChat: makeRoute("/your-mission/chat"),

	// === Share Manifest ===
	ShareManifest: makeRoute("/share-manifest"),

	// === Settings ===
	Settings: makeRoute("/settings"),
	Profile: makeRoute("/settings/profile"),
	Notifications: makeRoute("/settings/notifications"),

	// === Shared ===
	SharedFriendCheck: makeRoute(
		"/share/friend-check",
		z.object({ id: z.string().optional(), hash: z.string().optional() }),
	),
	SharedFriendCheckQuestions: makeRoute("/share/friend-check/questions"),
	SharedFriendCheckThankYou: makeRoute("/share/friend-check/thank-you"),

	// === Auth ===
	Auth: makeRoute("/auth"),

	AuthSignIn: makeRoute("/auth/sign-in"),
	AuthSignInPassword: makeRoute("/auth/sign-in/password"),
	AuthSignInMagic: makeRoute(
		"/auth/sign-in/magic",
		z.object({
			error: z
				.union([
					z.literal("google_signin_cancelled"),
					z.literal("apple_signin_cancelled"),
					z.string(),
				])
				.optional(),
			email: z.string().optional(),
		}),
	),
	AuthSignInMagicVerify: makeRoute("/auth/sign-in/magic/verify"),

	AuthSignUp: makeRoute("/auth/sign-up"),
	AuthSignUpVerify: makeRoute("/auth/sign-up/verify"),
	AuthSignUpPassword: makeRoute("/auth/sign-up/password"),
	AuthSignUpProfile: makeRoute("/auth/sign-up/profile"),

	AuthForgotPassword: makeRoute("/auth/forgot-password"),
	AuthForgotPasswordVerify: makeRoute("/auth/forgot-password/verify"),
	AuthForgotPasswordReset: makeRoute("/auth/forgot-password/reset"),

	AuthOAuthRedirect: makeRoute(
		"/auth/oath/redirect",
		z.object({
			accessToken: z.string().optional(),
			refreshToken: z.string().optional(),
			error: z.string().optional(),
		}),
	),

	NoAccess: makeRoute("/no-access", z.object({ path: z.string().optional() })),
};
